import script from "./ShowcaseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowcaseItem.vue?vue&type=script&setup=true&lang=js"

import "./ShowcaseItem.vue?vue&type=style&index=0&id=c57a9fec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57a9fec"]])

export default __exports__